<div class="custom-modal">
    <div class="modal-header py-4 mt-3">
        <h4 class="modal-title font-18">{{ title }}</h4>
    </div>
    <div class="modal-body">
            <div class="editor_wrapper">
                <code-editor [ngModel]="json" [readOnly]="true" language="json"></code-editor>
                <fa-icon (click)="copyToClipboard()" ngbTooltip="Copy to Clipboard" class="copy_button" [icon]="['fas', 'copy']"></fa-icon>
            </div>
    </div>
    
    <div class="modal-footer my-3">
        <button type="submit" class="btn btn-outline" (click)="activeModal.close()">Chiudi</button>
    </div>
</div>
